// Path: ./src/app/components/ImageSearchModal/index.tsx
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import styled from "styled-components";
import {
  AdvancedSearchConfigDto,
  GfImage,
} from "@swagger/typescript-fetch-goflyer";
import { SideFlyerGridList } from "../SideFlyerGridList";
import { SearchInputWithAdvanced } from "../SearchInputWithAdvanced";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 1,
  borderRadius: 2,
  outline: "none",
  width: { xs: "98%", md: "90%", lg: 835 },
};

interface Props {
  open: boolean;
  handleClose: () => void;
  itemsList?: GfImage[];
  // eslint-disable-next-line
  onItemClick?: (value: GfImage) => void;
  // eslint-disable-next-line
  // onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // searchText?: string;

  /**
   * Handles the search action after pressing enter or clicking on the search button.
   */
  onSearch?: (value: string, advancedConfig?: AdvancedSearchConfigDto) => void;
  hasMore: boolean;
  getMoreGfImage: (
    value: string,
    advancedConfig?: AdvancedSearchConfigDto,
  ) => void;
  isSearchingImage: boolean;
  /**
   * File upload handler for selecting local images
   */
  onFileUpload?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line
  onTagEdit?: (image: GfImage) => void;
  /**
   * Whether to enable keyword suggestions
   * @default true
   */
  enableKeywordSuggestions?: boolean;
  /**
   * Z-index for the modal
   * @default 1300
   */
  zIndex?: number;
}

/**
 * search window from the pop up modal window in the create flyer item page
 * @param param0
 * @returns
 */
export function ImageSearchModal({
  open,
  handleClose,
  itemsList,
  onItemClick,
  // searchText,
  onSearch,
  // onChange,
  hasMore = false,
  getMoreGfImage,
  isSearchingImage = false,
  onFileUpload,
  onTagEdit,
  enableKeywordSuggestions = true,
  zIndex = 1300,
}: Props) {
  const dataTestId = "gfImage-modal";

  const [searchText, setSearchText] = useState("");
  const [infiniteScrollKey, setInfiniteScrollKey] = useState("infiniteKey");
  const [advancedSearchConfig, setAdvancedSearchConfig] = useState<
    AdvancedSearchConfigDto | undefined
  >(undefined);

  const handleSearchSubmit = (
    value: string,
    advancedConfig?: AdvancedSearchConfigDto,
  ) => {
    setSearchText(value);
    setInfiniteScrollKey(value);
    setAdvancedSearchConfig(advancedConfig);
    onSearch && onSearch(value, advancedConfig);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      data-testid={dataTestId}
      sx={{ zIndex }}
    >
      <Box sx={style}>
        <Wrapper>
          <SearchInputWithAdvanced
            onSearch={handleSearchSubmit}
            dataTestId={`${dataTestId}`}
            placeHolder="Search"
            enableKeywordSuggestions={enableKeywordSuggestions}
            enableAdvancedSearch={true}
            zIndex={zIndex + 1}
          />
          <SideFlyerGridList
            hasMore={hasMore}
            itemsList={itemsList}
            onItemClick={onItemClick}
            gridStyle={`
            box-shadow:none;
            background-color:transparent;
          `}
            dataTestId={`${dataTestId}-images`}
            getMore={() => getMoreGfImage(searchText, advancedSearchConfig)}
            searchText={infiniteScrollKey}
            isLoading={isSearchingImage}
            onFileUpload={onFileUpload}
            onTagEdit={onTagEdit}
            containerStyle={{
              maxHeight: "80vh",
              height: "80vh",
            }}
          />
        </Wrapper>
      </Box>
    </Modal>
  );
}

const Wrapper = styled.div``;
